<template>
  <app-modal name="clone-invoice-result-modal" :title="title" @before-open="beforeOpen"  hide-footer>
    <h5 v-if="invoiceErrors.length > 0" class="text-red"><i class="fal fa-exclamation-circle"></i> {{$t('invoice.cloneError')}}: </h5>
    <ul v-if="invoiceErrors.length > 0">
      <li class="text-red" v-for="error in invoiceErrors">
        {{$t('invoice.invoiceNo')}} - {{error.id}} : {{error.text}}
      </li>
    </ul>
    <h5 v-if="successInvoices.length > 0" class="text-green" :class="{'mt-0': invoiceErrors.length === 0, 'mt-5': invoiceErrors.length > 0 }"><i class="fal fa-check-circle"></i> {{$t('invoice.cloneSuccess')}}: </h5>
    <ul v-if="successInvoices.length > 0">
      <li class="text-green" v-for="inv in successInvoices">
        {{$t('invoice.invoiceNo')}} - {{inv.invoice_no}}
      </li>
    </ul>
  </app-modal>
</template>

<script>
import AppModal from '@/components/app-modal/';
import AppForm from '@/components/app-form/';

export default {
  name: 'CloneInvoiceResultModal',
  components: {
    AppModal,
    AppForm,
  },
  data() {
    return {
      invoiceErrors: [],
      title: this.$t('invoice.importedInvoice'),
      successInvoices: [],
    };
  },
  methods: {
    beforeOpen(params) {
      const vm = this;
      this.invoiceErrors = [];
      this.successInvoices = [];
      const errorInvoices = params.importedInvoices.filter(i => !i.id);
      this.successInvoices = params.importedInvoices.filter(i => i.id);
      if (errorInvoices.length > 0) {
        errorInvoices.forEach((r) => {
          if (!r.id && r.error) {
            vm.invoiceErrors.push({ id: r.invoice_no, text: Object.keys(r.error).reduce((text, k) => text + r.error[k], '') });
          }
        });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/portal-components/invoice/clone-invoice-result-modal.vue